import { Reveal } from "@/components/Reveal";

export function SectionHeading({ overline, title, subtitle, align = "left" }) {
  return (
    <Reveal className={align === "center" ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
      {overline && (
        <p className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-4">{overline}</p>
      )}
      <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-white leading-[1.05]">
        {title}
      </h2>
      {subtitle && <p className="mt-5 text-base text-neutral-400 leading-relaxed">{subtitle}</p>}
    </Reveal>
  );
}

export function PageHero({ overline, title, subtitle, image }) {
  return (
    <section className="relative overflow-hidden grain">
      <div className="absolute inset-0">
        <img src={image} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-black/60" />
        <div className="absolute inset-0 hero-scrim" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-8 pt-24 pb-16">
        <Reveal>
          {overline && <p className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-4">{overline}</p>}
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white max-w-3xl leading-[1.02]">
            {title}
          </h1>
          {subtitle && <p className="mt-6 text-lg text-neutral-300 max-w-2xl leading-relaxed">{subtitle}</p>}
        </Reveal>
      </div>
    </section>
  );
}
